$( document ).ready( function() {
    /**
     * Close Modal with ESC key
     */
    document.onkeydown = function(evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key === "Escape" || evt.key === "Esc");
        } else {
            isEscape = (evt.keyCode === 27);
        }
        if (isEscape) {
            closeFlightModal();
        }
    };

    /**
     * Close Modal Function
     */
    function closeFlightModal() {
        if ($('#flight_modal_overlay').length > 0 && $('#flight_modal').length > 0) {
            $('body').removeClass('modalOpened');

            const flightModal = $('#flight_modal');

            $('#flight_modal_overlay').css({
                'visibility' : 'hidden',
                'opacity' : 0,
            });

            setTimeout(function(){
                /**
                 * Clearing the content added from the previous row
                 */
                flightModal.find('#flight_modal__flight_number').text('');
                flightModal.find('#flight_modal__airline_contacts .contacts__airline_name').text('');
                flightModal.find('#flight_modal__airline_contacts .contacts__phone_number').text('');
                flightModal.find('#flight_modal__airline_contacts .contacts__web').text('');
                flightModal.find('#flight_modal_dest_title').text('');
                flightModal.find('#flight_modal__from').text('');
                flightModal.find('#flight_modal__scheduled').text('');
                flightModal.find('#flight_modal__date').text('');
                flightModal.find('#flight_modal__expected').text('');
                flightModal.find('#flight_modal__status').text('');
                flightModal.find('#flight_modal__terminal').text('');
                flightModal.find('#flight_modal__aircraft_model').text('');
                flightModal.find('#flight_modal__gate').text('');
                flightModal.find('#flight_modal__descs').text('');
                flightModal.find('#flight_modal__belt').text('');
                flightModal.find('.flight_modal__code_logo img').attr('src', '');

                /**
                 * Ground Handling Operator
                 */
                flightModal.find('#flight_modal__agent_descr .flight_modal_subtitle').text('');
                flightModal.find('#flight_modal__agent_text').html('');

                flightModal.find('#flight_modal__airline_logo img').attr('src', '');

                flightModal.find('.contacts__phone_number')
                    .attr('href', '#')
                    .text('');
                flightModal.find('.contacts__web')
                    .attr('href', '')
                    .text('');

                /**
                 * Code Share
                 */
                flightModal.find('#flight_modal__code #flight_modal__code_info img').attr('src', '');
                flightModal.find('#flight_modal__code .contacts__airline_name').text('');
                flightModal.find('#flight_modal__code .contacts__phone_number')
                        .attr('href', '')
                        .text('');
                flightModal.find('#flight_modal__code .contacts__web')
                        .attr('href', '')
                        .text('');

                $('#flight_modal__code').hide();
            }, 500);
        }
    }

    if ( $('#flight_modal_overlay').length > 0 && $('#flight_modal').length > 0) {

        //open flight modal
        $('.info-modal table tbody tr, .seasonal_flights_results .day_container .modalTrigger').click( function() {
            $('#flight_modal__code').hide();
            $('body').addClass('modalOpened');



            if (typeof $(this).attr('data-flight') !== 'undefined') {
                const flightModal = $('#flight_modal');

                var data_type = $(this).attr('data-type');
                var data_flight = JSON.parse($(this).attr('data-flight'));
                var destination = $(this).find('.destination__name').contents().not($(".destination__name").children()).text();
                var airport_name = $(this).find('.destination__name .airport__name').attr('data-full-airport');

                if (data_type == "normal") {
                    var data_ghos = JSON.parse(flightModal.attr('data-ghos'));
                } else {
                    flightModal.find('.hiddenOnSeasonal').hide();
                    destination = $(this).find('.destination__name').text();
                    airport_name = $(this).find('.flights_data_airport').text();
                }

                /**
                 * Fill the content
                 */
                if (typeof $(this).attr('data-airline') !== 'undefined' && $(this).attr('data-airline') !== "") {
                    var current_airline = JSON.parse($(this).attr('data-airline'));

                    flightModal.find('#flight_modal__airline #flight_modal__airline_logo img').attr('src', current_airline.logo);

                    flightModal.find('#flight_modal__airline #flight_modal__airline_contacts .contacts__airline_name').text(current_airline.name);
                    flightModal.find('#flight_modal__airline #flight_modal__airline_contacts .contacts__phone_number')
                        .attr('href', 'tel:' + current_airline.phone)
                        .text(current_airline.phone);
                    flightModal.find('#flight_modal__airline #flight_modal__airline_contacts .contacts__web')
                        .attr('href', "https://" + current_airline.website)
                        .text(current_airline.website);
                }

                flightModal.find('#flight_modal__flight_number').text(data_flight.f);
                let dest_title = "";

                if(window.location.href.indexOf("/bg/") > -1) {
                    if ( data_flight.ad == "A" ) {
                        dest_title = 'От';
                    } else {
                        dest_title = 'До';
                    }
                } else {
                    if ( data_flight.ad != "D" ) {
                        dest_title = 'From';
                    } else {
                        dest_title = 'To';
                    }
                }

                /**
                 * Depending on what type the flight is,
                 * we're hiding the unrelated column entries
                 */
                if (data_flight.ad == "D") {
                    $('#flight__modal-gate').show();
                    $('#flight__modal-descs').show();
                    $('#flight__modal-belt').hide();
                } else {
                    $('#flight__modal-gate').hide();
                    $('#flight__modal-descs').hide();
                    $('#flight__modal-belt').show();
                }

                flightModal.find('#flight_modal_dest_title').text(dest_title);
                flightModal.find('#flight_modal__from').text(destination);
                flightModal.find('#flight_modal__from__airport').text(airport_name);
                flightModal.find('#flight_modal__scheduled').text(data_flight.t);
                flightModal.find('#flight_modal__date').text(data_flight.d);
                flightModal.find('#flight_modal__terminal').text(data_flight.ter);
                
                if (data_type == "normal") {

                    flightModal.find('#flight_modal__aircraft_model').text(data_flight.jet);
                    flightModal.find('#flight_modal__expected').text(data_flight.est);
                    if (data_flight.msg_bg.trim() || data_flight.msg_en.trim()) {
                        if (window.location.href.indexOf("/bg/") > -1) {
                            flightModal.find('#flight_modal__message').text(data_flight.msg_bg);
                        } else {
                            flightModal.find('#flight_modal__message').text(data_flight.msg_en);
                        }
                    } else {
                        flightModal.find('#flight_modal__message__wrapper').css("display", "none");
                    }

                    if (window.location.href.indexOf("/bg/") > -1) {
                        flightModal.find('#flight_modal__status').text(data_flight.st_bg);
                    } else {
                        flightModal.find('#flight_modal__status').text(data_flight.st_en);
                    }

                    if (data_flight.gn !== "" && data_flight.gn !== " ") {
                        flightModal.find('#flight_modal__gate').text(data_flight.gn);
                    }

                    if (data_flight.dcs !== "" && data_flight.dcs !== " ") {
                        flightModal.find('#flight_modal__descs').text(data_flight.dcs);
                    }

                    if (data_flight.belt !== "" && data_flight.belt !== " ") {
                        flightModal.find('#flight_modal__belt').text(data_flight.belt);
                    }

                    if (typeof $(this).attr('data-codeshare') !== 'undefined') {
                        if ($(this).attr('data-codeshare') !== "") {
                            $('#flight_modal__code').show();
                            var codeshare = JSON.parse($(this).attr('data-codeshare'));

                            flightModal.find('#flight_modal__code #flight_modal__code_info img').attr('src', codeshare.logo);
                            flightModal.find('#flight_modal__code .contacts__airline_name').text(codeshare.name);
                            flightModal.find('#flight_modal__code .contacts__phone_number')
                                       .attr('href', 'tel:' + codeshare.phone)
                                       .text(codeshare.phone);
                            flightModal.find('#flight_modal__code .contacts__web')
                                       .attr('href', "https://" + codeshare.website)
                                       .text(codeshare.website);
                        }
                    }

                    /**
                     * Ground Handling Operator
                     */
                    if (data_flight.gho !== "") {
                        var gho = data_flight.gho;
                        flightModal.find('#flight_modal__agent_descr .flight_modal_subtitle').text(data_ghos[gho].name);
                        if (data_flight.ad == "D") {
                            if (data_ghos[gho].information_dep) {
                                flightModal.find('#flight_modal__agent_text').html(data_ghos[gho].information_dep);
                            }
                        } else {
                            if (data_ghos[gho].information_arr) {
                                flightModal.find('#flight_modal__agent_text').html(data_ghos[gho].information_arr);
                            }
                        }
                    }
                }
            }

            $('#flight_modal_overlay').scrollTop(0);

            $('#flight_modal_overlay').css({
                'visibility' : 'visible',
                'opacity' : 1
            });

        });

        //close flight modal
        $('#flight_modal__close, #flight_modal__close_btn').click(function() {
            closeFlightModal();
        });
    }
});